import React, { useState } from 'react';
import {
  Grid,
  Card,
  CardHeader,
  Divider,
  CardContent,
  Button,
  CardActions,
  makeStyles,
  Theme,
  createStyles,
} from '@material-ui/core';
import { AutoFocusedForm, PhotoField, required, TextField } from 'components';
import { Field } from 'react-final-form';
import { useNotificationForm } from './useNotificationForm';
import { Alert } from '@material-ui/lab/';

import { BroadcastRecipientField } from './BroadcastRecipientField';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: 500,
    },
    header: {
      fontWeight: 'bolder',
    },
    imageFile: {
      width: 200,
    },
    divider: {},
    content: {},
    actions: {
      justifyContent: 'flex-end',
    },
  })
);

export interface CreateVersionFormProps {
  onClose: () => void;
}

export const CreateNotificationForm = ({ onClose }: CreateVersionFormProps) => {
  const styles = useStyles();
  const [typeRecipientList, setTypeRecipientList] = useState<string>('');
  const { onSubmit, initialValues } = useNotificationForm({
    onClose,
    typeRecipientList,
  });

  return (
    <AutoFocusedForm
      onSubmit={onSubmit}
      initialValues={initialValues}
      subscription={{
        submitError: true,
      }}
      render={({ handleSubmit, pristine, submitError, values }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Card className={styles.root}>
              <CardHeader title="Добавление уведомления" />
              <Divider className={styles.divider} />
              <CardContent className={styles.content}>
                <Grid container spacing={4}>
                  <Grid item lg={12} md={12} xl={12} xs={12}>
                    <Field
                      name="radioType"
                      component={BroadcastRecipientField}
                      selectedValue={typeRecipientList}
                      setSelectedValue={setTypeRecipientList}
                      label="Получатели *"
                      type="radio"
                      validate={required}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={4}>
                  <Grid item lg={12} md={12} xl={12} xs={12}>
                    <Field
                      name="title"
                      label="Заголовок *"
                      component={TextField}
                      validate={required}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={4}>
                  <Grid item lg={12} md={12} xl={12} xs={12}>
                    <Field
                      name="text"
                      label="Текст *"
                      component={TextField}
                      validate={required}
                      multiline={true}
                      rows={3}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item lg={6} md={6} xl={6} xs={6}>
                    <Field
                      name="buttonText"
                      label="Текст кнопки"
                      validate={values.buttonUrl ? required : undefined}
                      component={TextField}
                      multiline={true}
                    />
                  </Grid>
                  <Grid item lg={6} md={6} xl={6} xs={6}>
                    <Field
                      name="buttonUrl"
                      label="URL перехода"
                      component={TextField}
                      validate={values.buttonText ? required : undefined}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={4}>
                  <Grid item lg={4} md={4} xl={3} xs={4}>
                    <Field className={styles.imageFile} name="images" component={PhotoField} />
                  </Grid>
                </Grid>
                {submitError && <Alert severity="error">{submitError}</Alert>}
              </CardContent>
              <CardActions className={styles.actions}>
                <Button
                  color="primary"
                  disabled={pristine}
                  size="medium"
                  type="submit"
                  variant="contained"
                >
                  Добавить
                </Button>
                <Button onClick={onClose} size="medium" type="button" variant="contained">
                  Отменить
                </Button>
              </CardActions>
            </Card>
          </form>
        );
      }}
    />
  );
};
